import { AxiosError } from 'axios';
import { useState } from 'react';

import { LookupCountInterface } from '../../../models/dashboard/dashboard/lookup-count';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { lookupCountActions } from '../../../redux/slices/lookupCountSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetLookupCount = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onGetLookupCountError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onGetLookupCountSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<LookupCountInterface>) => {
        dispatch(lookupCountActions.setLookupCountData(data));
    };

    const getLookupCount = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/lookup-units`,
            method: 'get',
        };

        return request(url, onGetLookupCountSuccess, setLoading, onGetLookupCountError);
    };

    return { getLookupCount, loading };
};

export default useGetLookupCount;
